import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '../../services/auth-api/models/index';
import { RoleEnum } from '../../services/auth-api/enums/role.enum';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  constructor(public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    let user: User | undefined = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') ?? '')
      : null;

    const allowedRoles: Array<string> = 'allowedRoles' in next.data 
    ? next.data['allowedRoles'] as string[]
    : [];

    if (!user?.roles 
      || user === null 
      || (allowedRoles.length > 0 && !user.roles?.find(role => allowedRoles.includes(role)))) {
      this.router.navigate(['/auth/login']);
      return true;
    } else if (user) {
      if (!Object.keys(user).length) {
        this.router.navigate(['/auth/login']);
        return true;
      }
    }
    return true;
  }
}
